var quizQuestions = [
    {
        question: "Who Said It: \"I would tell members of my family, and I have, I wouldn't go anywhere in confined places right now. It's not that it's going to Mexico, it's that you are in a confined aircraft. When one person sneezes, it goes everywhere through the aircraft. That's me.\"",
        answers: [
            {
                type: "correct",
                content: "Joe Biden"
            },
            {
                type: "incorrect",
                content: "Donald Trump"
            },
            {
                type: "incorrect",
                content: "Mark Schlissel"
            }
        ]
    },
    {
      question: "Who Said It: \“Unions are great.\”",
      answers: [
                {
                    type: "incorrect",
                    content: "Joe Biden"
                },
                {
                    type: "incorrect",
                    content: "Donald Trump"
                },
                {
                    type: "correct",
                    content: "Mark Schlissel"
                }
      ]
    },
    {
      question: "Who Said It: \“I have so many websites. I have them all over the place... I hire people... It costs me three dollars.\"",
      answers: [
                {
                    type: "incorrect",
                    content: "Joe Biden"
                },
                {
                    type: "correct",
                    content: "Donald Trump"
                },
                {
                    type: "incorrect",
                    content: "Mark Schlissel"
                }
      ]
    },
    {
      question: "Who Said It: \"I know nothing about the inter [sic] workings of Russia.\"",
      answers: [
                {
                    type: "incorrect",
                    content: "Joe Biden"
                },
                {
                    type: "correct",
                    content: "Donald Trump"
                },
                {
                    type: "incorrect",
                    content: "Mark Schlissel"
                }
      ]
    },
    {
      question: "Who Said It: \“You must go forth into the world, with passion, courage in your conviction, and most importantly be true to yourself. I did it!\”",
      answers: [
                {
                    type: "incorrect",
                    content: "Joe Biden"
                },
                {
                    type: "correct",
                    content: "Donald Trump"
                },
                {
                    type: "incorrect",
                    content: "Mark Schlissel"
                }
      ]
    },
    {
      question: "Who Said It: \"I mean, you got the first mainstream African-American who is articulate and bright and clean and a nice-looking guy.\”",
      answers: [
                {
                    type: "correct",
                    content: "Joe Biden"
                },
                {
                    type: "incorrect",
                    content: "Donald Trump"
                },
                {
                    type: "incorrect",
                    content: "Mark Schlissel"
                }
      ]
    },
   {
     question: "Who Said It: \“We’re not here to be predatory land owners; we have tons of land.\”",
     answers: [
               {
                   type: "incorrect",
                   content: "Joe Biden"
               },
               {
                   type: "incorrect",
                   content: "Donald Trump"
               },
               {
                   type: "correct",
                   content: "Mark Schlissel"
               }
     ]
   },
   {
     question: "Who Said It: \"The largest growth of population is Indian Americans, moving from India. You cannot go to a 7-11 or a Dunkin' Donuts unless you have a slight Indian accent. I'm not joking.\"",
     answers: [
               {
                   type: "correct",
                   content: "Joe Biden"
               },
               {
                   type: "incorrect",
                   content: "Donald Trump"
               },
               {
                   type: "incorrect",
                   content: "Mark Schlissel"
               }
     ]
   },
   {
     question: "Who Said It: \“We’re still defining what carbon neutral means.\”",
     answers: [
               {
                   type: "incorrect",
                   content: "Joe Biden"
               },
               {
                   type: "incorrect",
                   content: "Donald Trump"
               },
               {
                   type: "correct",
                   content: "Mark Schlissel"
               }
     ]
   },
   {
     question: "Who Said It: \"I think if this country gets any kinder or gentler, it's literally going to cease to exist.\"",
     answers: [
               {
                   type: "incorrect",
                   content: "Joe Biden"
               },
               {
                   type: "correct",
                   content: "Donald Trump"
               },
               {
                   type: "incorrect",
                   content: "Mark Schlissel"
               }
     ]
   },
   {
     question: "Who Said It:  \“Sometimes testing can give you a false sense of security.\”",
     answers: [
               {
                   type: "incorrect",
                   content: "Joe Biden"
               },
               {
                   type: "incorrect",
                   content: "Donald Trump"
               },
               {
                   type: "correct",
                   content: "Mark Schlissel"
               }
     ]
   },
   {
     question: "Who Said It: \“There’s an old saying – all men are created equal but then a few became firefighters.\”",
     answers: [
               {
                   type: "correct",
                   content: "Joe Biden"
               },
               {
                   type: "incorrect",
                   content: "Donald Trump"
               },
               {
                   type: "incorrect",
                   content: "Mark Schlissel"
               }
     ]
   },
   {
     question: "Who Said It: \“I'm conservative, and even very conservative. But I'm quite liberal and getting much more liberal on health care and other things. I really say: What's the purpose of a country if you're not going to have defensive [sic] and health care?\” ",
     answers: [
               {
                   type: "incorrect",
                   content: "Joe Biden"
               },
               {
                   type: "correct",
                   content: "Donald Trump"
               },
               {
                   type: "incorrect",
                   content: "Mark Schlissel"
               }
     ]
   }
  
  ];
  
  export default quizQuestions;